import EntityFormsModal from './EntityFormsModal';

export default EntityFormsModal;
